import { AlternateIdentifier } from "@/generated/raid";

export const alternateIdentifierDataGenerator = (): AlternateIdentifier => {
  return {
    id: "",
    type: "",
  };
};
